import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Duplicate = forwardRef<SVGSVGElement, SvgIconProps>(
  function Duplicate(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="m5.86722,17c-0.4336,0 -0.86722,-0.34875 -0.86722,-0.8724l0,-10.2552c0,-0.4357 0.34668,-0.8724 0.86722,-0.8724l10.26556,0c0.4336,0 0.86722,0.34875 0.86722,0.8724l0,10.2552c-0.08693,0.52365 -0.4336,0.8724 -0.95414,0.8724l-10.17864,0zm10.13278,-11l-10,0l0,10l10,0l0,-10zm-8.9174,13c-0.59716,0 -1.0826,-0.52811 -1.0826,-1.08368l11.91357,0l0,-11.91632c1.0826,0 1.0826,1.08368 1.0826,1.08368l0,10.83264c0.05992,0.59821 -0.59614,1.08368 -1.0826,1.08368l-10.83097,0zm4.51696,-8.60023l0,-2.39977l-1.19912,0l0,2.39977l-2.40044,0l0,1.20046l2.40044,0l0,2.39977l1.19912,0l0,-2.39977l2.40044,0l0,-1.20046l-2.40044,0z" />
      </SvgIcon>
    )
  },
)

export default Duplicate
